import { FormSelect } from '@systemeio/ui'
import EditTriggerWrapper from 'modules/automation-rules/triggers/components/edit-triggers/components/edit-trigger-wrapper'
import { EditTriggerItemInterface } from 'modules/automation-rules/triggers/components/edit-triggers/types/edit-trigger-item-interface'
import { AutomationRuleTriggersDataEnum } from 'modules/automation-rules/triggers/enums/trigger-enum'
import { TriggerDigitalStoreFormSubscribedEditInterface } from 'modules/automation-rules/triggers/types/automation-rule-triggers-edit-interface'
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data'
import React from 'react'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { OpenInNewIcon } from '@systemeio/ui'

interface TriggerDigitalStoreItemProps
  extends EditTriggerItemInterface<TriggerDigitalStoreFormSubscribedEditInterface> {}

const TriggerDigitalStoreItem = ({
  triggers,
  trigger,
  idx,
  onDelete,
  setRules,
  errors,
  isStatic,
}: TriggerDigitalStoreItemProps) => {
  const { t } = useLocoTranslation()

  return (
    <EditTriggerWrapper trigger={trigger} onDelete={() => onDelete(idx)}>
      {({ renderTriggerLabel, data, onOpen, onClear }) => (
        <>
          <FormSelect
            disabled={isStatic}
            onOpen={() => onOpen(AutomationRuleTriggersDataEnum.digital_store_form_subscribed)}
            label={renderTriggerLabel({
              label: t('dashboard.store.title'),
              additionalLabel: trigger.digitalStore.id ? (
                <LinkWithoutPrefetch
                  href={`/stores/${trigger.digitalStore.id}`}
                  className={`group self-center outline-hidden`}
                  target={'_blank'}
                >
                  <OpenInNewIcon
                    className={
                      'main-transition-colors group-focus-visible:fill-brand-primary hover:fill-brand-primary'
                    }
                  />
                </LinkWithoutPrefetch>
              ) : undefined,
            })}
            placeholder={t('dashboard.automation_rule.choose_store')}
            value={trigger.digitalStore.id}
            staticData={getDataFromObj(trigger.digitalStore)}
            data={data.digitalStoresData}
            onChange={data => {
              setRules(prev => {
                return {
                  ...prev,
                  triggers: triggers.map((el, i) => {
                    if (idx === i) {
                      return {
                        ...el,
                        digitalStore: { id: data },
                        itemOptIn: { id: undefined },
                      }
                    } else {
                      return el
                    }
                  }),
                }
              })
            }}
            error={errors.automationTriggers[trigger.id]?.digitalStoreId?.join('')}
          />
          {trigger.digitalStore.id && (
            <FormSelect
              disabled={isStatic}
              onOpen={() => onOpen(AutomationRuleTriggersDataEnum.digital_store_form_subscribed)}
              label={renderTriggerLabel({
                label: t('dashboard.automation_rule.store_optin'),
              })}
              placeholder={t('dashboard.automation_rule.choose_store_optin')}
              staticData={[
                {
                  id: trigger.itemOptIn.id,
                  caption: trigger.itemOptIn.title || '',
                },
              ]}
              value={trigger.itemOptIn.id}
              data={data.digitalStoreOptInsData}
              onChange={data =>
                setRules(prev => {
                  return {
                    ...prev,
                    triggers: triggers.map((el, i) => {
                      if (idx === i) {
                        return {
                          ...el,
                          itemOptIn: {
                            id: data,
                          },
                        }
                      } else {
                        return el
                      }
                    }),
                  }
                })
              }
              error={errors.automationTriggers[trigger.id]?.itemOptInId?.join('')}
            />
          )}
        </>
      )}
    </EditTriggerWrapper>
  )
}

export default TriggerDigitalStoreItem
